import { section } from '@/glow';
import { AnimateTestimonials } from '@/lib/animation';

section('testimonials', {
  onLoad() {
    this.AnimateTestimonials = AnimateTestimonials(this.container);
  },

  onUnload() {
    this.AnimateTestimonials?.destroy();
  }
});
